import api from '../callApi';
import clientIdCustom from './clientIdCustom';
import { getGoogleAnalyticsClientId } from './googleAnalytics';

const trackingUrl = 'Widget/TrackingAsync';

function getActionData(action, actionCancelTime) {
    return {
        id: action.id,
        actionId: action.actionId,
        type: action.type,
        partnerId: action.partner ? action.partner.id : null,
        order: action.order,
        issueId: action.issue ? action.issue.id : null,
        subIssueId: action.subIssue ? action.subIssue.id : null,
        widgetCardId: action.widgetCardId,
        cancelledTime: actionCancelTime,
        skipEndCard: action.skipEndCard
    };
}

function getRequestFromState(state, type, eventData, actionCancelTime) {
    return {
        clientIdCustom,
        type,
        articleUrl: state.widget.articleUrl,
        widgetId: state.widget.widgetId,
        widgetEmbedType: state.widget.embedType,
        widgetType: state.widget.widgetType,
        articleId: state.widget.articleId,
        publisherId: state.widget.publisherId,
        publishedDate: state.widget.publishedDate,
        clientId: getGoogleAnalyticsClientId(),
        location: {
            latitude: (state.widget.endUserLocation || {}).latitude,
            longitude: (state.widget.endUserLocation || {}).longitude
        },
        eventData,
        actions: [getActionData(state.widget.activeAction, actionCancelTime)],
        sponsored: state.widget.isSponsored
    };
}

function trackOpenAction(state) {
    const request = getRequestFromState(state, 'ActionInitiated');
    return api.post(trackingUrl, request);
}

function trackSharedAction(state, sharedWith) {
    const request = getRequestFromState(state, 'ActionShared', sharedWith);

    if (
        state.router.location.pathname !== '/multiActionsCard' &&
        state.router.location.pathname !== '/targetedMultiAction' &&
        state.router.location.pathname !== '/singleAction'
    ) {
        return api.post(trackingUrl, request);
    } else {
        return api.post(trackingUrl, {
            ...request,
            actions: state.widget.actions
                .filter(a => a.order === state.widget.activeAction.order)
                .map(a => getActionData(a))
        });
    }
}

function trackCancelAction(state, actionCancelTime) {
    const request = getRequestFromState(state, 'ActionCancelled', null, actionCancelTime);
    return api.post(trackingUrl, request);
}

function trackWidgetVisible(state) {
    const request = getRequestFromState(state, 'WidgetVisible');

    return api.post(trackingUrl, {
        ...request,
        actions: state.widget.actions.map(a => getActionData(a))
    });
}

function trackWidgetEngaged(state) {
    const request = getRequestFromState(state, 'Engaged');
    return api.post(trackingUrl, request);
}

function trackActionVisible(state) {
    const request = getRequestFromState(state, 'ActionVisible');
    return api.post(trackingUrl, request);
}

function trackNewsletterSubscription(state) {
    const request = getRequestFromState(state, 'NewsletterSubscription');
    return api.post(trackingUrl, request);
}

export default {
    trackOpenAction,
    trackSharedAction,
    trackCancelAction,
    trackWidgetVisible,
    trackActionVisible,
    trackNewsletterSubscription,
    trackWidgetEngaged
};



// WEBPACK FOOTER //
// ./src/utils/tracking/apiTracking.js